// Helpers para o dataLayer do GTM. Os nomes de eventos e variáveis seguem
// o contrato do site antigo (meucupom.com-site), usado pelo container GTM.
export const pushData = (data) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  } catch {
    // tracking nunca deve quebrar a navegação
  }
};

export const pushEvent = (event, payload = {}) => pushData({ event, ...payload });

// Vínculo com clube validado (ex.: "clubeDoAlunoIsValid", "promoveIsValid"),
// igual ao persistSave dos serviços de clube do site antigo (válido por 1 dia).
export const pushClubValidation = (key) => {
  pushEvent('persistSave', {
    user: {
      [key]: true,
      [`${key}Expire`]: new Date().getTime() + 86400000,
    },
  });
};

export const AUTH_CHANGED_EVENT = 'mc:auth-changed';
export const notifyAuthChanged = () => {
  try {
    window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
  } catch {
    // ignorado
  }
};

// Extrai o id de tracking ("C<id>") que o backend adiciona ao link de afiliado
// (POST /coupon/redirect). Links sem rede de afiliado voltam sem esse id.
export const getClickIdFromLink = (link) => {
  try {
    const url = new URL(link);
    if (url.searchParams.get('afsrc') !== '1') return null;
    for (const value of url.searchParams.values()) {
      if (/^C\d+$/.test(value)) return value;
    }
  } catch {
    // link inválido
  }
  return null;
};
